module.exports = __webpack_public_path__ + "img/04n_color.ed83f19a.png";